import { render, staticRenderFns } from "./DetalhePagamento.vue?vue&type=template&id=d4d60b5c"
import script from "./DetalhePagamento.vue?vue&type=script&lang=js"
export * from "./DetalhePagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports